import { Alert, Platform } from 'react-native';

type ConfirmActionOptions = {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
};

/**
 * Cross-platform confirm. RN Web's Alert.alert ignores button callbacks,
 * so web uses window.confirm.
 */
export function confirmAction(options: ConfirmActionOptions): Promise<boolean> {
  const confirmLabel = options.confirmLabel ?? 'Delete';
  const cancelLabel = options.cancelLabel ?? 'Cancel';

  if (Platform.OS === 'web') {
    if (typeof window === 'undefined') return Promise.resolve(false);
    return Promise.resolve(
      window.confirm(`${options.title}\n\n${options.message}`),
    );
  }

  return new Promise((resolve) => {
    Alert.alert(options.title, options.message, [
      {
        text: cancelLabel,
        style: 'cancel',
        onPress: () => resolve(false),
      },
      {
        text: confirmLabel,
        style: 'destructive',
        onPress: () => resolve(true),
      },
    ]);
  });
}
